const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/ExternalPage/ExternalPage.tsx';
import { RouteComponentProps } from 'react-router';

import { PageLayout } from '../../layout/PageLayout';
import { AppBar } from './AppBar/AppBar';

/**
 * React props
 */
export interface IExternalPageProps {}

/**
 * URI parameters as injected by react-router-redux.
 */
interface IRouteParams {
    title: string;
    url: string;
}

/**
 * React props including injected props
 */
type IExternalPageImplProps = IExternalPageProps & RouteComponentProps<IRouteParams>;

/**
 * Functional React component
 */
export const ExternalPage = (props: IExternalPageImplProps) => {
    const url = decodeURIComponent(props.match.params.url);
    return (
        <PageLayout
            appBar={<AppBar title={decodeURIComponent(props.match.params.title)} />}
            noPaddingAroundContent
            disableVerticalScrolling
        >
            <iframe id="ExternalPage" width="100%" height="100%" src={url} />
        </PageLayout>
    );
};
